/**
 * @description 将url请求参数转为json格式
 * @param url
 * @returns {{}|any}
 */
export function paramObj(url, bol = true) {
  if (bol) {
    const search = url.split("?")[1];
    if (!search) {
      return {};
    }
    return JSON.parse(
      '{"' +
        decodeURIComponent(search)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"')
          .replace(/\+/g, " ") +
        '"}'
    );
  } else {
    if (!url) {
      url = window.location.href;
    }
    var urlObj = new URL(url);
    var queryParams = {};
    // 使用forEach以便可以自定义解码逻辑
    urlObj.searchParams.forEach((value, key) => {
      // 对查询参数值进行自定义解码，保留'+'字符
      queryParams[key] = value.replace(/\s/g, "+");
    });
    return queryParams;
  }
}
